// extracted by mini-css-extract-plugin
export default {"box":"imgmenu_box__fHLS1","active":"imgmenu_active__+-ZLs"};